export const lookupTableConstants = {
     LOOKUP_TABLE_LIST_REQUEST: "LOOKUP_TABLE_LIST_REQUEST",
     LOOKUP_TABLE_LIST_COMPLETE: "LOOKUP_TABLE_LIST_COMPLETE",

     LOOKUP_TABLE_SEARCH_REQUEST: "LOOKUP_TABLE_SEARCH_REQUEST",
     LOOKUP_TABLE_SEARCH_COMPLETE: "LOOKUP_TABLE_SEARCH_COMPLETE",

     LOOKUP_TABLE_ADD_REQUEST: "LOOKUP_TABLE_ADD_REQUEST",
     LOOKUP_TABLE_ADD_COMPLETE: "LOOKUP_TABLE_ADD_COMPLETE",

     LOOKUP_TABLE_UPDATE_REQUEST: "LOOKUP_TABLE_UPDATE_REQUEST",
     LOOKUP_TABLE_UPDATE_COMPLETE: "LOOKUP_TABLE_UPDATE_COMPLETE",

     LOOKUP_TABLE_DELETE_REQUEST: "LOOKUP_TABLE_DELETE_REQUEST",
     LOOKUP_TABLE_DELETE_COMPLETE: "LOOKUP_TABLE_DELETE_COMPLETE",

     LOOKUP_TABLE_GET_REQUEST: "LOOKUP_TABLE_GET_REQUEST",
     LOOKUP_TABLE_GET_COMPLETE: "LOOKUP_TABLE_GET_COMPLETE",

     LOOKUP_TABLE_TYPES_REQUEST: "LOOKUP_TABLE_TYPES_REQUEST",
     LOOKUP_TABLE_TYPES_COMPLETE: "LOOKUP_TABLE_TYPES_COMPLETE",

     LOOKUP_TABLE_LABELS_REQUEST: "LOOKUP_TABLE_LABELS_REQUEST",
     LOOKUP_TABLE_LABELS_COMPLETE: "LOOKUP_TABLE_LABELS_COMPLETE",

     LOOKUP_TABLE_ACTIVE_INACTIVE_REQUEST:
          "LOOKUP_TABLE_ACTIVE_INACTIVE_REQUEST",
     LOOKUP_TABLE_ACTIVE_INACTIVE_COMPLETE:
          "LOOKUP_TABLE_ACTIVE_INACTIVE_COMPLETE",

     LOOKUP_TABLE_VALUE_LIST_REQUEST: "LOOKUP_TABLE_VALUE_LIST_REQUEST",
     LOOKUP_TABLE_VALUE_LIST_COMPLETE: "LOOKUP_TABLE_VALUE_LIST_COMPLETE",

     LOOKUP_TABLE_VALUE_ADD_REQUEST: "LOOKUP_TABLE_VALUE_ADD_REQUEST",
     LOOKUP_TABLE_VALUE_ADD_COMPLETE: "LOOKUP_TABLE_VALUE_ADD_COMPLETE",

     LOOKUP_TABLE_VALUE_UPDATE_REQUEST: "LOOKUP_TABLE_VALUE_UPDATE_REQUEST",
     LOOKUP_TABLE_VALUE_UPDATE_COMPLETE: "LOOKUP_TABLE_VALUE_UPDATE_COMPLETE",

     LOOKUP_TABLE_VALUE_DELETE_REQUEST: "LOOKUP_TABLE_VALUE_DELETE_REQUEST",
     LOOKUP_TABLE_VALUE_DELETE_COMPLETE: "LOOKUP_TABLE_VALUE_DELETE_COMPLETE",

     LOOKUP_TABLE_VALUE_GET_REQUEST: "LOOKUP_TABLE_VALUE_GET_REQUEST",
     LOOKUP_TABLE_VALUE_GET_COMPLETE: "LOOKUP_TABLE_VALUE_GET_COMPLETE",

     LOOKUP_TABLE_CSV_FILE_UPLOAD_REQUEST: "LOOKUP_TABLE_CSV_FILE_UPLOAD_REQUEST",
     LOOKUP_TABLE_CSV_FILE_UPLOAD_COMPLETE: "LOOKUP_TABLE_CSV_FILE_UPLOAD_COMPLETE",   
     LOOKUP_TABLE_CSV_FILE_UPLOAD_CLEAR: "LOOKUP_TABLE_CSV_FILE_UPLOAD_CLEAR",  

     LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_REQUEST:'LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_REQUEST',
     LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_COMPLETE:'LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_COMPLETE',
     LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_CLEAR:'LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_CLEAR',

     LOOKUP_TABLE_SAVE_SEARCH_VALUES:'LOOKUP_TABLE_SAVE_SEARCH_VALUES',
     LOOKUP_TABLE_CHANGE_STATUS:'LOOKUP_TABLE_CHANGE_STATUS',

     CSV_FILE_TYPE:'text/csv'
};
